var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCertificate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.065,
    height: 18.71,
    viewBox: "0 0 16.065 18.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10606",
    "data-name": "Path 10606",
    d: "M17.28,2.871H13.549a2.628,2.628,0,0,0-5.034,0H4.785A1.835,1.835,0,0,0,3,4.742v13.1A1.835,1.835,0,0,0,4.785,19.71h12.5a1.835,1.835,0,0,0,1.785-1.871V4.742A1.835,1.835,0,0,0,17.28,2.871Zm-6.248,0a.937.937,0,1,1-.893.936A.917.917,0,0,1,11.033,2.871ZM8.614,15.3,6.3,12.881a.964.964,0,0,1,0-1.319.86.86,0,0,1,1.258,0l1.687,1.759L14.5,7.82a.86.86,0,0,1,1.258,0,.964.964,0,0,1,0,1.319L9.872,15.3a.86.86,0,0,1-1.258,0Z",
    transform: "translate(-3 -1)",
    fill: "#f0f0f0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.0d8a9a2b95b0b1d6311e22dda6576890.svg";
export { ForwardRef as ReactComponent };